import PredictionRuleModelFormFieldsVisitor from "./PredictionRuleModelFormFieldsVisitor.js";
import regionWidget from "../../../../../core/widgets/regionWidget.js";

/**
 * Todo: Add JSDoc comment
 */
export default function addPredictionRuleModelFieldsToForm({
	form,
	ruleModel,
	budgets,
}) {
	const widget = regionWidget();

	initializeForm({ form, widget, ruleModel, budgets });

	return widget;
}

function initializeForm({ form, widget, ruleModel, budgets }) {
	addPredictionModelRuleFieldsToForm({
		form,
		ruleModel,
		budgets,
	});

	widget.setContent(form);
}

function addPredictionModelRuleFieldsToForm({ form, ruleModel, budgets }) {
	const visitor = new PredictionRuleModelFormFieldsVisitor({
		form,
		budgets,
	});

	return ruleModel.accept(visitor);
}
